
































































































































































































































































































































































































import { AlertBus } from "../../plugins/alerts/AlertBus";
import Pagination from "@/components/shared/Pagination.vue";
import Vue from "vue";
import { Component, Inject, Prop, Provide } from "vue-property-decorator";
import i18n from "@/lang/i18n";
import {
  getMultiStoreId,
  getStoreId,
  getTenantId
} from "@/services/AuthService";
import {
  alertDangerReason,
  downloadFile,
  getLanguageId,
  translateMessageResult
} from "@/services/Helpers";
import { ShipmentService } from "@/services/ShipmentService";
import store from "@/vuex/store";
import Modal from "@/components/shared/modal/Modal.vue";
import { IPagination } from "@/model/component.model";
import {
  EcommerceOutcomeDto,
  MessageResult,
  ShipImportNotificationDto
} from "@/model/data.model";
import { CustomerService } from "@/services/CustomerService";
import { getKeyValueConfig } from "@/utils/fetchKeyValueConfigLevel";

@Component({
  components: {
    MbeModal: Modal,
    Pagination: Pagination
  }
})
export default class Importing extends Vue {
  @Prop() modalType: string;
  @Prop() typeAddressPickup: number;
  notificationType = "GENERIC_IMPORT";
  selectedImport = "";
  step = 1;
  attachment: any = null;
  attachmentFilename = "";
  notifications: any[] = [];
  shownNotifications: any[] = [];
  isToUSAPopup = false;
  importTypes: any = [];
  @Provide() CustomerService = new CustomerService();

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25]
  };

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.search();
  }

  search() {
    this.notifications = [];
    this.shownNotifications = [];
    if (this.modalType === "amazon") {
      this.getAmazonImportNotifications();
    } else if (this.modalType === "excel") {
      this.getImportNotifications();
    } else if (this.modalType === "addresses_excel") {
      this.getImportAddresses();
    }
  }

  created() {
    ShipmentService.prototype.getTaxAndDutyKeys().then((res: any) => {
      this.isToUSAPopup = getKeyValueConfig(
        res,
        "SYS_ACTIVATION_PRIOR_NOTICE_POPUP"
      );
    });
    this.nameSelected = 1;
    if (!this.$store.getters["customer/config"].pickupEnabled) {
      this.addressesPickups = [
        {
          name: "Addresses",
          key: 1
        }
      ];
    }

    if (this.modalType === "amazon") {
      if (this.isAmazonEnabled) {
        const amazonImport = {
          type: "ecommerce",
          label: i18n.t("import_amazon"),
          value: "AMAZON",
          allowedExtensions: ["txt"]
        };
        this.importTypes.push(amazonImport);
      }
    } else if (this.modalType === "excel") {
      const excelImport = {
        type: "excel",
        label: i18n.t("import_excel_shipment_logic"),
        value: "ONLINE",
        isImportShipments: true,
        allowedExtensions: ["xls", "xlsx"]
      };
      this.importTypes.push(excelImport);
    } else if (this.modalType === "addresses_excel") {
      this.notificationType = "ADDRESSES_IMPORT";
      const excelImport = {
        type: "excel",
        label: i18n.t("import_excel_address_logic"),
        value: "ONLINE",
        isImportShipments: true,
        allowedExtensions: ["xls", "xlsx"]
      };
      this.importTypes.push(excelImport);
    }

    //hide import excel for non dev envs
    if (!this.$store.getters.features.excel_import) {
      this.importTypes = this.importTypes.filter(item => {
        if (item.value === "AMAZON") return true;
        return false;
      });
    }
  }

  select(importType: any) {
    this.selectedImport = importType;
    this.step = 2;
  }
  getImportTemplate() {
    ShipmentService.getImportTemplate()
      .then(res => {
        const file = res.data;
        const fileName = String(res.headers["content-disposition"])
          .split('filename="')[1]
          .split('"')[0];
        downloadFile(file, "XLSX", fileName, this);
      })
      .catch((err: any) => {
        return alertDangerReason(err, this);
      });
  }

  processFiles($event: any) {
    const files = $event.target.files;
    const fileExtension = files[0].name.split(".").pop();

    const allowedExtensionsItem = this.importTypes.find(
      (item: any) => item.value === this.selectedImport
    );

    if (!allowedExtensionsItem.allowedExtensions.includes(fileExtension)) {
      return this.$alerts.danger(i18n.t("invalid_filetype"));
    }
    this.attachmentFilename = files[0].name;
    this.attachment = files[0];
  }

  upload() {
    const formData: any = new FormData();
    formData.append("file", this.attachment);
    if (this.modalType !== "addresses_excel") {
      if (this.selectedImport === "AMAZON") {
        //Added this interceptor, because now it's not async so I don't use the std API
        ShipmentService.importAmazonShipments(formData)
          .then((res: any) => {
            // Compose final message
            const uiMsg: Function = this.$alerts.success;
            this.step = 1;
            uiMsg(i18n.t("shipments_import_amazon_started")).then(res => {
              this.$emit("close");
            });
          })
          .catch((reason: any) => {
            if (reason.code && reason.code === "ECONNABORTED") {
              setTimeout(() => {
                AlertBus.$alerts
                  .danger(i18n.t("shipments_import_amazon_timeout"))
                  .then(() => {
                    this.$router.push({ name: "ShipmentsMenuNew" });
                  });
              }, 100);
              return Promise.reject(reason);
            } else {
              return alertDangerReason(reason, this);
            }
          });
        return;
      }

      formData.append("template", this.selectedImport);
      formData.append("multistoreId", getMultiStoreId());
      formData.append("storeId", getStoreId());
      formData.append("userId", store.getters.user.id);

      ShipmentService.importShipment(formData)
        .then((res: any) => {
          this.step = 1;
          this.$notify.success(String(i18n.t("import_successful")));
        })
        .catch((reason: any) => {
          if (reason.code && reason.code === "ECONNABORTED") {
            setTimeout(() => {
              AlertBus.$alerts
                .danger(i18n.t("shipments_import_timeout"))
                .then(() => {
                  this.$router.push({ name: "ShipmentsMenuNew" });
                });
            }, 100);
            return Promise.reject(reason);
          } else {
            return alertDangerReason(reason, this);
          }
        });
    } else {
      let typeAddress = "";
      if (this.nameSelected == 1) {
        typeAddress = "SHIPMENT";
      } else if (this.nameSelected == 2) {
        typeAddress = "OPERATION";
      }
      this.CustomerService.importCustomer(
        formData,
        store.getters.customer.info.customerId,
        typeAddress
      )
        .then((res: any) => {
          this.step = 1;
          this.$notify.success(String(i18n.t("import_successful")));
        })
        .catch(reason => {
          return alertDangerReason(reason, this);
        });
    }
  }

  getImportNotifications() {
    ShipmentService.getImportNotificationsPaged(
      getStoreId(),
      store.getters.user.username,
      this.pagination.perPage,
      this.pagination.currentPage - 1,
      undefined
    ).then(data => {
      this.pagination.totalElements = data.totalElements;
      this.notifications = data.content;
      this.shownNotifications = this.notifications
        .map((entity: ShipImportNotificationDto) => {
          entity.shipImportMappingsErrorEntities = entity.shipImportMappingsErrorEntities.filter(
            (item: any) =>
              item.status === "error" ||
              item.status === "ERROR" ||
              item.status === "warning" ||
              item.status === "WARNING"
          );
          entity.insertDate = new Date(entity.insertDate);
          return entity;
        })
        .sort(
          (a: any, b: any) =>
            a.rowNumber - b.rowNumber || a.columnNumber - b.columnNumber
        );
      this.notificationType = "GENERIC_IMPORT";
      this.shownNotifications.forEach((value: ShipImportNotificationDto) => {
        value.shipImportMappingsErrorEntities = value.shipImportMappingsErrorEntities.map(
          item => {
            let errorDetail = "";
            let errorStatus = "";
            if (item.status === "error" || item.status === "ERROR") {
              errorDetail = item.errorMessage;
              errorStatus = item.status;
            } else if (item.status === "WARNING" || item.status === "warning") {
              item.status = "WARNING_import";
              errorDetail = item.errorMessage;
              errorStatus = item.status;
            } else {
              const message = JSON.parse(item.errorDetail) as MessageResult;
              errorDetail = translateMessageResult(message);
              errorStatus = message.responseType;
            }
            return {
              rowNumber: item.rowNumber,
              columnNumber: item.columnNumber,
              orderNumber: item.idShipImportMappingsError,
              messageType: errorStatus,
              errorDetail: errorDetail
            };
          }
        );
      });
      this.step = 3;
    });
  }

  getAmazonImportNotifications() {
    ShipmentService.getEcommerceOutcome(
      this.pagination.perPage,
      this.pagination.currentPage - 1,
      undefined,
      "AMAZON"
    ).then(res => {
      this.pagination.totalElements = res.totalElements;
      this.notifications = res.content;
      this.shownNotifications = this.notifications
        .map((entity: EcommerceOutcomeDto) => {
          const results = entity.ecommerceOutcomeDetails
            .map(item => {
              if (item.messageType === "WARNING")
                item.messageType = "WARNING_import";
              const result = {
                rowNumber: item.idEcommerceOutcomeDetails,
                orderNumber: item.orderNumber,
                messageType: String(i18n.t(item.messageType)),
                errorDetail: item.message
              };
              return result;
            })
            .sort(
              (a: any, b: any) =>
                a.rowNumber - b.rowNumber || a.columnNumber - b.columnNumber
            );

          if (entity.messageType === "WARNING") {
            entity.messageType = "WARNING_import";
          }
          return {
            insertDate: entity.insertDate,
            fileName: entity.fileName,
            shipImportMappingsErrorEntities: results,
            id: entity.idEcommerceOutcome,
            messageType: String(i18n.t(entity.messageType))
          };
        })
        .sort((a: any, b: any) => b.id - a.id);
      this.notificationType = "ECOMMERCE_IMPORT";
      this.step = 3;
    });
  }

  nameSelected = 1 as number;

  addressesPickups = [
    {
      name: "Addresses",
      key: 1
    },
    {
      name: "Pickups",
      key: 2
    }
  ];

  updateSelected(item: any) {
    this.nameSelected = item.key;
    this.$emit("onTabChange", item);
  }

  isActive(item: any): boolean {
    return item.key === this.typeAddressPickup;
  }

  getImportAddresses() {
    this.notifications = [];

    this.CustomerService.getImportDetailErrors(
      getStoreId(),
      store.getters.user.username,
      store.getters.customer.info.customerId
    ).then((res: any) => {
      this.notifications = res.content;
      this.notifications.forEach((el: any) => {
        el.show = false;
        el.importedCustomerContactResultEntities = el.importedCustomerContactResultEntities.sort(
          (a: any, b: any) =>
            Number(a.rowPosition) > Number(b.rowPosition)
              ? 1
              : Number(b.rowPosition) > Number(a.rowPosition)
              ? -1
              : 0
        );
      });
      this.step = 3;
    });
  }

  tableRowClassName({ row, rowIndex }: any): string {
    let klass = "";
    if (
      row.shipImportMappingsErrorEntities.filter(
        (el: any) => el.status === "error"
      ).length
    ) {
      klass += "warning-row";
    } else {
      klass += "success-row";
    }
    if (!row.shipImportMappingsErrorEntities.length) {
      klass += " row-expand-cover";
    }
    return klass;
  }

  tableRowDetailsClassName({ row, rowIndex }: any): string {
    let klass = "";
    if (row.status === "error") {
      klass += "warning-row";
    } else {
      klass += "success-row";
    }
    if (!row.shipImportMappingsErrorEntities.length) {
      klass += " row-expand-cover";
    }
    return klass;
  }

  // Getters
  get tenantCode() {
    return getLanguageId(getTenantId());
  }

  get isAmazonEnabled() {
    return this.$store.getters["customer/config"].amazonEnabled;
  }
}
